import React, { useState, useEffect } from "react";
import orderService from "../../db/order-service";
import "./OrdersByProductId.scss";

const OrdersByProductId = (props) => {
  const [orderListByProductId, setOrderListByProductId] = useState([]);
  const productId = props.productId;

  // Currency symbols by country
  const currencySymbols = {
    'US': '$',
    'IN': '₹',
    'GB': '£',
    'EU': '€',
    'JP': '¥'
  };

  useEffect(() => {
    const fetchOrdersByProduct = async () => {
      try {
        // Use PouchDB order service instead of API call
        const orders = await orderService.findOrdersByProductId(productId);
        
        // Enhance orders with country information
        const enhancedOrders = orders.map(order => ({
          ...order,
          country: detectCountryFromAddress(order.shippingAddress || '')
        }));
        
        setOrderListByProductId(enhancedOrders);
      } catch (err) {
        console.log("Error fetching orders by product:", err);
      }
    };
    
    if (productId) {
      fetchOrdersByProduct();
    }
  }, [productId]);

  // Simple function to detect country from address
  const detectCountryFromAddress = (address) => {
    if (!address) return 'US'; // Default
    
    const addressLower = address.toLowerCase();
    
    if (addressLower.includes('india') || addressLower.includes('mumbai') || 
        addressLower.includes('delhi') || addressLower.includes('bangalore')) {
      return 'IN';
    }
    
    if (addressLower.includes('uk') || addressLower.includes('united kingdom') || 
        addressLower.includes('london') || addressLower.includes('england')) {
      return 'GB';
    }
    
    if (addressLower.includes('europe') || addressLower.includes('germany') || 
        addressLower.includes('france') || addressLower.includes('spain')) {
      return 'EU';
    }
    
    if (addressLower.includes('japan') || addressLower.includes('tokyo')) {
      return 'JP';
    }
    
    return 'US'; // Default to US
  };

  // Format price based on country
  const formatPrice = (price, country) => {
    const symbol = currencySymbols[country] || '$';
    return `${symbol}${parseFloat(price).toFixed(2)}`;
  };

  return (
    <div className="orders-by-product">
      <h1>Orders of This Product</h1>
      {orderListByProductId.length === 0 ? (
        <p className="no-orders">No orders found for this product.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Order Id</th>
              <th>Customer Name</th>
              <th>Order Date</th>
              <th>Country</th>
              <th>Quantity</th>
              <th>Total Cost</th>
            </tr>
          </thead>
          <tbody>
            {orderListByProductId.map((order) => {
              return (
                <tr key={order.orderId}>
                  <td>{order.orderId}</td>
                  <td>
                    {order.fname} {order.lname}
                  </td>
                  <td>{order.createdDate}</td>
                  <td>{order.country}</td>
                  <td>{order.quantity}</td>
                  <td>{formatPrice(order.totalPrice, order.country)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OrdersByProductId;